// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__8YYj-","products":"Search_products__ahSHw","header":"Search_header__H6dS0","goBack":"Search_goBack__za3jO","title":"Search_title__qBLSp"};